import 'boxicons'

import './menu.js'
import './modules/slider.js'
import './modules/logos.js'
import './modules/avis.js'
import './modules/alert.js'
import './modules/map.js'
import './modules/form.js'
import './modules/filter.js'
import './video.js'



// WEBPACK FOOTER //
// ./scripts/main.js